import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'lib-rs-ng-steps',
  templateUrl: './rs-ng-steps.component.html',
  styleUrls: ['./rs-ng-steps.component.scss']
})
export class RsNgStepsComponent implements OnInit {
  @Input() styleName = "style1"
  @Input() stepsList = []; //æ­¥éª¤æ¡æ°ç»
  @Input() contentList = []; //æ­¥éª¤æ¡å¯¹åºç»ä»¶æ°ç» 
  @Input() stepsConfig = {}; //èªå®ä¹éç½®ä¸æ ä¿¡æ¯  
  @Input() stepIndex = 0; //å®ä¹åå§å¼ä¿¡æ¯
  customIndex = 0;
  status = true;// ä¿®æ¹æé®å¤æ­
  type;//å¤æ­é¡µé¢ æ¯æ°å¢è¿æ¯ç¼è¾  å­å¨è¡¨ç¤ºæ¯æ°å¢é¡µé¢
  constructor(private activatedRoute: ActivatedRoute) {
  }
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(queryParam => {
      this.type = queryParam.type
    });
    if (this.type) {
      this.status = false;
      this.customIndex = 0;
      this.stepIndex=0;
      return
    }
    if (this.stepIndex && this.stepsConfig['isCustomIndex']) {
      this.customIndex = this.stepsConfig['endIndex']
    }
  }

  //ç»å®åç´ çéèæ¾ç¤º
  handleEleHide(i) {
    /**
     * å¦æåå§åç´ å­å¨åç´æ¥è¿åfalse åå§æ¾ç¤ºææåç´ 
     */
    return this.status ? false : (this.stepsConfig['isCustomIndex'] ? this.customIndex : this.stepIndex) !== i
  }
  //ä¸ä¸æ­¥å¤ç
  handlePreChange() {
    if (this.stepIndex === 0) {
      return
    }
    this.stepIndex--;
    this.customIndex=this.stepIndex;
  }
  // ç¹å»ä¿®æ¹å¤çæä½
  handleChangeStepIndex(i) {
    if (this.stepsConfig['isCustomIndex']) {
      this.customIndex = i;
    }
    this.stepIndex = i;
    this.status = false;
    this.handleEleHide(i);

  }
  //ä¸ä¸æ­¥å¤ç

  
  handleNextChange() {
    if (this.stepIndex === this.stepsList.length - 1) {
      if (this.stepsConfig['isCustomIndex']) {
        this.customIndex = this.stepsConfig['isCustomIndex']['endIndex'] || (this.stepIndex - 1)
        return
      }
      return
    }
    this.stepIndex++;
    (this.stepsConfig['isCustomIndex'] && this.stepIndex !== this.stepsList.length - 1) && this.customIndex++
  }
}
